import { IndexRouteObject, NonIndexRouteObject, useMatches } from "react-router";
import type { HelpTopicKey } from "src/helpers/helpRouteCatalog";

export interface HelpRouteHandle { help?: { topicKey: HelpTopicKey } | null }
export type AppRouteObject = (
    Omit<IndexRouteObject, "handle"> |
    (Omit<NonIndexRouteObject, "children" | "handle"> & { children?: AppRouteObject[] })
) & { handle?: HelpRouteHandle };

export function getRouteHelp(matches: readonly { handle?: unknown }[]): HelpTopicKey | null {
    for (let i = matches.length - 1; i >= 0; i--) {
        const handle = matches[i].handle as HelpRouteHandle | undefined;
        if (handle && Object.prototype.hasOwnProperty.call(handle, "help")) return handle.help?.topicKey ?? null;
    }
    return null;
}
export default function useRouteHelp(): HelpTopicKey | null {
    return getRouteHelp(useMatches());
}
